import {
  CalendarIcon,
  ComponentIcon,
  EpicIcon,
  FlagIcon,
  SprintIcon,
  StatusIcon,
  TagIcon,
  TicketsIcon,
  UserIcon,
} from "app/components/Icons";
import ProjectIcon from "app/components/Icons/ProjectIcon";
import ReleaseIcon from "app/components/Icons/ReleaseIcon";
import TimeIcon from "app/components/Icons/TimeIcon";
import checkListIcon from "assets/svgs/ic_checklist.svg";
import descriptionIcon from "assets/svgs/ic_description.svg";
import ticketIdIcon from "assets/svgs/ID.svg";
import figmaOutline from "assets/svgs/solar_figma-outline.svg";
import teamIcon from "assets/svgs/team.svg";
import ticketNameIcon from "assets/svgs/ticket-name.svg";
import React from "react";
import { ITicketTypes } from "./types";

export const getTWorkItemFiledIcon = (type: string) => {
  switch (type) {
    case "teamName":
      return <img src={teamIcon} alt="TicketNameIcon" className=" h-6 w-6 " />;
    case "projectName":
      return <ProjectIcon size={24} color="#79808A" />;
    case "epicName":
      return <EpicIcon size={24} color="#79808A" />;
    case "componentName":
      return <ComponentIcon size={30} color="#79808A" />;
    case "releaseName":
      return <ReleaseIcon size={24} color="#79808A" />;
    case "sprintName":
      return <SprintIcon size={24} color="#79808A" />;
    case "ticketID":
      return (
        <img src={ticketIdIcon} alt="TicketNameIcon" className=" h-6 w-6 " />
      );
    case "ticketName":
      return (
        <img src={ticketNameIcon} alt="TicketNameIcon" className=" h-6 w-6 " />
      );
    case "ticketType":
      return <TicketsIcon size={24} color="#79808A" />;
    case "status":
      return <StatusIcon size={24} color="#79808A" />;
    case "priority":
      return <FlagIcon size={24} color="#79808A" />;
    case "assignee":
      return <UserIcon size={24} color="#79808A" />;
    case "effortsEstimated":
    case "effortsActual":
      return <TimeIcon size={24} color="#79808A" />;
    case "dueDate":
      return <CalendarIcon size={24} color="#79808A" />;
    case "tags":
      return <TagIcon size={24} color="#79808A" />;
    case "ticketDescription":
      return <img src={descriptionIcon} alt="des-icon" className=" h-6 w-6 " />;
    case "actionItems":
      return <img src={checkListIcon} alt="check-icon" className=" h-6 w-6 " />;
    case "figmaAssets":
      return <img src={figmaOutline} alt="figma-icon" className=" h-6 w-6 " />;
    default:
      return;
  }
};

export function getTicketTypeByIds(
  types: ITicketTypes[],
  ids: string | string[],
): ITicketTypes[] {
  if (!Array.isArray(types) || !ids) return [];

  const idArray = Array.isArray(ids) ? ids : [ids];
  return types.filter((m) => idArray.includes(m._id));
}

export const filterActiveTicketTypes = (types: ITicketTypes[] = []) => {
  return types.filter((type) => type.isActive);
};
export const filterTicketTypes = (types: ITicketTypes[] = []) => {
  return types.filter((type) => !type.isContainerLevel && !type.isArchived);
};
